class ImageStorage {
    constructor() {
        if (ImageStorage._instance) {
            return ImageStorage._instance;
        }

        this.uploadedImage = null;
        this.backgroundImage = null;
        this.transparentImage = null;

        ImageStorage._instance = this;
    }

    setUploadedImage(image) {
        this.uploadedImage = image;
    }

    setBackgroundImage(image) {
        this.backgroundImage = image;
    }

    setTransparentImage(image) {
        this.transparentImage = image;
    }

    getUploadedImage() {
        return this.uploadedImage;
    }

    getBackgroundImage() {
        return this.backgroundImage;
    }

    getTransparentImage() {
        return this.transparentImage;
    }
    
    hasSomeImage() {
        return this.uploadedImage != null || this.backgroundImage != null || this.transparentImage != null;
    }
    
    clear() {
        this.uploadedImage = null;
        this.backgroundImage = null;
        this.transparentImage = null;
    }
}

const imageStorage = new ImageStorage();
export default imageStorage;